<template>
    <div>
        <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
            <el-tab-pane label="订单列表" name="orderFormList"></el-tab-pane>
        </el-tabs>
        <router-view class="router-view"></router-view>
    </div>
</template>

<script lang="ts">
import { createComponent, onMounted, ref } from "@vue/composition-api"
import { routerUtil } from '@/utils/routerUtil'

export default createComponent({
    setup(props, ctx) {
       onMounted(()=> {
            window.location.href = 'https://ls.senguo.cc/newadmin/#/main/order/orderCashier'
        })

        const {
            activeTabName,
            handleTabClick
        } = routerUtil(ctx)

        return {
            activeTabName,
            handleTabClick
        }
    }
})
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
    margin-bottom: 12px;
}

.router-view {
    height: calc(100vh - 134px);
}
</style>
